import React from 'react';
import SelectIncidentModal from './SelectIncidentModal';
import { Outlet, useParams } from 'react-router';
import { useExactIncident } from './hooks/incidentHooks';
import Loader from '../Loader/Loader';
import { validate as validateUUID } from 'uuid';

const IAPWrapper = () => {
  const { incidentId } = useParams<{ incidentId: string }>();

  const isValidIncidentId = incidentId && validateUUID(incidentId);

  const { data: incident, isLoading } = useExactIncident(
    incidentId ?? 'invalid'
  );

  if (!isValidIncidentId) {
    // Short circuit any loading of invalid incident ids
    return <SelectIncidentModal />;
  }

  return incident ? (
    <Outlet />
  ) : isLoading ? (
    <Loader showLoading={true} fullscreen={false} />
  ) : (
    <SelectIncidentModal />
  );
};

export default IAPWrapper;
